import { useState, useContext, createContext, useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
const BASE_URL = process.env.REACT_APP_BASE_API;

const GlobalContext = createContext(null);

export const GlobalContextProvider = ({ children }) => {
  const [isToggled, setIsToggled] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token') || '');

  useEffect(() => {
    localStorage.setItem('token', token);

    if (token) {
      const headers = new Headers();
      headers.append("Authorization", token);

      fetch(`${BASE_URL}/auth/users/me`, { headers })
        .then(async (response) => {
          const { data } = await response.json();

          if (data && typeof data === 'object') {
            setUser(data);
          } else {
            setToken('');
          }
        })
    }
  }, [token])

  let signin = (user, callback = () => { }) => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    console.log({ user })
    fetch(
      `${BASE_URL}/login`,
      {
        headers,
        method: 'POST',
        body: JSON.stringify({
          ...user,
          uuid: user.password
        })
      }
    ).then(async (response) => {
      let token = '';
      const { data = {} } = await response.json();

      if (data && typeof data === 'object') {
        token = data.token;
        setToken(token)
      }

      callback(token);
    })
  };

  let signout = (callback = () => { }) => {
    setToken('');
    callback();
  };


  const handleToggle = () => setIsToggled(!isToggled);

  return (
    <GlobalContext.Provider value={{
      token,
      isToggled,
      handleToggle,
      token,
      user,
      signin,
      signout
    }}>
      {children}
    </GlobalContext.Provider>
  );
}

export const useGlobal = () => useContext(GlobalContext);

export const RequireAuth = ({ children }) => {
  let { token } = useGlobal();
  let location = useLocation();

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}